import React from "react";
import { Link } from "gatsby";

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
  EuiHideFor,
} from "@elastic/eui";

import IntroCards from "./IntroInternetToC";
import IntroCardsMobile from "./IntroInternetToC_mobile";

export default function IntroHome() {
  return (
    <React.Fragment>
      <EuiSpacer />
      <EuiTitle size="m">
        <h2>Remote Access</h2>
      </EuiTitle>
      <EuiTitle size="s">
        <h4>
          Use your Camera's P2P or DDNS Service to access it over the Internet
        </h4>
      </EuiTitle>
      <div>
        <ul>
          <li>
            <Link to="/Web_User_Interface/1440p_Series/Network/IP_Configuration/#ipv6-port-forwarding">
              IPv6 Port Port Forwarding (for UHD Camera Modells)
            </Link>
          </li>
          <li>
            <Link to="/Schnell_Installation/Internet_Protocol_IPv6/">
              What is IPv6 and how does SLAAC work?
            </Link>
          </li>
          <li>
            <Link to="/Frequently_Asked_Question/WQHD_IPv6_Portforwarding/">
              Instructions for IPv6 port activation in an AVM Fritzbox
            </Link>
          </li>
        </ul>
      </div>
      <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup
        gutterSize="l"
        direction="column"
        style={{ margin: "0 7px" }}
      >
        <EuiFlexItem>
          <EuiHideFor sizes={["xs", "s", "m", "l"]}>
            <IntroCards />
          </EuiHideFor>
          <EuiHideFor sizes={["xl"]}>
            <IntroCardsMobile />
          </EuiHideFor>
        </EuiFlexItem>
      </EuiFlexGroup>
    </React.Fragment>
  );
}
